export const MAX_SCHEDULE_BULK_SELECTION = 500;

/** Bulk adjust / group drag / bulk delete require at least this many selected matches. */
export const MIN_SCHEDULE_BULK_ADJUST = 2;
